export default __webpack_public_path__ + "static/media/about-us-icon-recycling.94a1fe60.png";